import { CareersCarousel } from '@/features/CareersCarousel';
import { generateStyleModifiers } from '@/utils/generateStyleModifiers';

const IntegrationCareers = (props) => {
    const modifiers = generateStyleModifiers(props.appliedCssClassNames);
    const theme = modifiers.theme;

    return <CareersCarousel {...props} theme={theme} isInEditor={props.isInEditor} />;
};

export default IntegrationCareers;
